/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Pick_DateInputs */

const en_plan_pick_date = /** @type {(inputs: Plan_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

const es_plan_pick_date = /** @type {(inputs: Plan_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir una fecha`)
};

/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Plan_Pick_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_pick_date = /** @type {((inputs?: Plan_Pick_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Pick_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_pick_date(inputs)
	return en_plan_pick_date(inputs)
});